// extracted by mini-css-extract-plugin
export default {"audio-play-button":"Button_audio-play-button__kkDio"};